import { API_BASE_URL } from './index';
import { getToken, getUser } from './auth';

export const strategiesApi = {
  getStrategies: async () => {
    const token = getToken();
    const user = getUser();

    if (!token) {
      throw new Error('No authentication token');
    }
    if (!user?.companyId) {
      throw new Error('Company ID not available');
    }

    const response = await fetch(`${API_BASE_URL}/api/strategies`, {
      headers: {
        'Content-Type': 'application/json',
        'X-Session-Token': token,
        'X-Company-ID': user.companyId,
      },
    });

    if (!response.ok) {
      const error = await response.json().catch(() => ({ error: 'Failed to load strategies' }));
      throw new Error(error.error || 'Failed to load strategies');
    }

    return response.json();
  },

  getStrategy: async (id) => {
    const token = getToken();
    const user = getUser();

    if (!token) {
      throw new Error('No authentication token');
    }
    if (!user?.companyId) {
      throw new Error('Company ID not available');
    }

    const response = await fetch(`${API_BASE_URL}/api/strategies/${id}`, {
      headers: {
        'Content-Type': 'application/json',
        'X-Session-Token': token,
        'X-Company-ID': user.companyId,
      },
    });

    if (!response.ok) {
      const error = await response.json().catch(() => ({ error: 'Failed to load strategy' }));
      throw new Error(error.error || 'Failed to load strategy');
    }

    return response.json();
  },

  createStrategy: async (data) => {
    const token = getToken();
    const user = getUser();

    if (!token) {
      throw new Error('No authentication token');
    }
    if (!user?.companyId) {
      throw new Error('Company ID not available');
    }

    const response = await fetch(`${API_BASE_URL}/api/strategies`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Session-Token': token,
        'X-Company-ID': user.companyId,
      },
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      const error = await response.json().catch(() => ({ error: 'Failed to create strategy' }));
      throw new Error(error.error || 'Failed to create strategy');
    }

    return response.json();
  },

  updateStrategy: async (id, data) => {
    const token = getToken();
    const user = getUser();

    if (!token) {
      throw new Error('No authentication token');
    }
    if (!user?.companyId) {
      throw new Error('Company ID not available');
    }

    const response = await fetch(`${API_BASE_URL}/api/strategies/${id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'X-Session-Token': token,
        'X-Company-ID': user.companyId,
      },
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      const error = await response.json().catch(() => ({ error: 'Failed to update strategy' }));
      throw new Error(error.error || 'Failed to update strategy');
    }

    return response.json();
  },

  deleteStrategy: async (id) => {
    const token = getToken();
    const user = getUser();

    if (!token) {
      throw new Error('No authentication token');
    }
    if (!user?.companyId) {
      throw new Error('Company ID not available');
    }

    const response = await fetch(`${API_BASE_URL}/api/strategies/${id}`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        'X-Session-Token': token,
        'X-Company-ID': user.companyId,
      },
    });

    if (!response.ok) {
      const error = await response.json().catch(() => ({ error: 'Failed to delete strategy' }));
      throw new Error(error.error || 'Failed to delete strategy');
    }

    return response.json();
  },
};

